export const tableHeaders = [
  {
    id: 1,
    label: 'UTC Time',
    intlKey: 'table.utc_date_time'
  },
  {
    id: 2,
    label: 'Local Time',
    intlKey: 'table.date_time'
  },
  {
    id: 3,
    label: 'Description',
    intlKey: 'table.description'
  }
]
